import React, {useEffect, useState} from 'react';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getActionDetailsCall, getPaymentCouponsCall, loginWithOneTimeTokenCall} from "../../../api/ApiCalls";
import {updateAuthDataNEWRS, updateShowAuthModalRS} from "../../../redux/reduxActions/reduxStoreActions";
import {appWords} from "../../../config/Constants";
import {storageKeys} from "../../../config/storageKeysConstants";
import CouponDetailAndPurchaseSection
    from "../../../components/AppSections/WebshopSections/CouponDetailAndPurchaseSection";
import {tokenErrorAlertFunction} from "../../../uitls/AlertFunctions";
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {failedAlertFunction, successAlertFunction} from "../../../uitls/AlertFunctions";
import {dateFormat, hasAValue} from "../../../uitls/SharedFunctions";
import { useHandleLinkClick } from '../../../hooks/useHandleLinkClick';
import {Helmet} from "react-helmet";

export default function CouponInfoAndPurchase() {

    let initStrings = {
        link_expired: stringsTranslate(appWords.link_expired),
        the_payment_failed: stringsTranslate(appWords.the_payment_failed),
        your_voucher_code: stringsTranslate(appWords.your_voucher_code),
        until: stringsTranslate(appWords.until),
        valid_from: stringsTranslate(appWords.valid_from),
    }


    const appLanguageRS = useSelector(state => state.appLanguageRS);
    const authDataNEWRS = useSelector(state => state.authDataNEWRS);
    const showLoginLinkModalRS = useSelector(state => state.showLoginLinkModalRS);
    const dispatch = useDispatch()
    const {payment_id, id} = useParams()
    let contentLanguage = appLanguageRS === "en"? "en": "nl"
    const history = useHistory();
    const location = useLocation();
    const [completedPurchase, setCompletedPurchase] = useState(false);

    const [webshopAction, setWebshopAction] = useState(null);
    const [isRedirect, setIsRedirect] = useState(false);
    const [isLoggingIn, setIsLoggingIn] = useState(() => {
        const params = new URLSearchParams(location.search);
        return !!params.get('token');
    });
    const [hasShownLoginModal, setHasShownLoginModal] = useState(false);
    const handleLinkClick = useHandleLinkClick();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (token) {
            oneTimeTokenLogin(token, params)
        }
        if(payment_id){
            getPaymentCoupons(payment_id, id)
        }
    }, [])

    useEffect(() => {
        getActionDetails(id);  // Pass the id here
    }, [id]);

    useEffect(() => {
        if(isRedirect && hasAValue(webshopAction) )
            handleLinkClick("/studentenkorting/Amesterdam/"+ encodeURIComponent(webshopAction.localization[contentLanguage].subtitle) + '/' + webshopAction.id);
    }, [webshopAction, isRedirect]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const hasToken = params.get('token');

        // Only open modal if:
        // 1. User is NOT authenticated
        // 2. No token-based login in progress
        // 3. No payment completion in progress
        // 4. Email verification modal is NOT already open
        // 5. Haven't already shown the login modal on this page load
        if (!hasToken && !payment_id && !showLoginLinkModalRS && !hasShownLoginModal && (!authDataNEWRS || !authDataNEWRS.accessToken)) {
            // Always update redirectUrl to current webshop page
            // This ensures user returns to the LAST webshop page they visited, not the first
            sessionStorage.setItem(storageKeys.REDIRECT_URL, location.pathname);
            dispatch(updateShowAuthModalRS(true));
            setHasShownLoginModal(true);
        }
    }, [authDataNEWRS, payment_id, showLoginLinkModalRS, hasShownLoginModal]);

    return (
        <div className="homepage-4 pt-5 mt-5">
            <Helmet>
                <title>{`Knaek - ${webshopAction?.company?.name} - ${webshopAction?.localization[contentLanguage]?.subtitle}`}</title>
            </Helmet>
            <div className="main">
                    <>
                        {!isLoggingIn && <CouponDetailAndPurchaseSection webshopAction={webshopAction} completedPurchase={completedPurchase} showUserCoupons={showUserCoupons} />}
                    </>
            </div>
        </div>
    );
    async function oneTimeTokenLogin(token, params) {
        function invalidLinkFeedback() {
            tokenErrorAlertFunction(initStrings.link_expired, "")
            setTimeout(() => {
                // window.location.href = "/"
            }, 3000);
        }

        try {
            const response = await loginWithOneTimeTokenCall({token});
            if (!response) {
                invalidLinkFeedback();
                return;
            }
            dispatch(updateAuthDataNEWRS({
                accessToken: response.data.access_token,
                refreshToken: response.data.refresh_token,
                city_id: response.data.city_id,
            }));
            // Close login modal if it was opened
            dispatch(updateShowAuthModalRS(false));
            setIsLoggingIn(false);

            if (params.has('token')) {
                params.delete('token');
                history.replace({ search: params.toString() });
            }

            setTimeout(() => {
                if (response.data?.goal?.toString().includes("APP_TO_WEB_REDIRECTION")) {
                    // window.location.href = "/account/online-bespaard#openClaim"
                } else {
                    // window.location.href = "/"
                }
            }, 500);

        } catch (e) {
            setIsLoggingIn(false);
            invalidLinkFeedback();
        }
    }

    async function getActionDetails(id) {
        try {
            const data = await getActionDetailsCall(id);
            if(data.type === 'COUPONS')
                handleLinkClick("/studentenkorting/Amesterdam/"+ encodeURIComponent(data.localization[contentLanguage].subtitle) + '/' + data.id);
            setWebshopAction(data);
        } catch (e) {
            console.log(e);
        }
    }

    function redirectToDiscountPage()
    {
        setIsRedirect(true)
    }

    async function showUserCoupons(vouchers) {
        if(vouchers.length > 0)
        {
            setCompletedPurchase(true)
            let vouchersMessage = ''
            vouchers.forEach(voucher => {
                vouchersMessage += '<p class="action-voucher-code">' + initStrings.your_voucher_code + ': <b><span >' + voucher.voucher + '</span></b></p>'
                vouchersMessage += '<p class="action-voucher-date">(' + initStrings.valid_from + ' ' + dateFormat(voucher.startDate) + ' ' + initStrings.until + ' ' + dateFormat(voucher.endDate) + ')</p>'
            });
            successAlertFunction(vouchersMessage , '', redirectToDiscountPage)

        }
    }

    async function getPaymentCoupons(payment_id, discount_id) {
        try {
            const response = await getPaymentCouponsCall(payment_id, discount_id);
            showUserCoupons(response.data);
        } catch (e) {
            failedAlertFunction(initStrings.the_payment_failed, '')
        }
    }



}
